import { useContext } from 'react';
import { cn } from '@/helpers/utils/functionality-utils';
import {
  ThemeProvider,
  type Theme,
  defaultDarkModeOverride,
  AccountSettings,
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { LayoutContext } from '@/layout/context/context';
import { useNavigate } from 'react-router';

const ResetPsPage = () => {
  const { layoutConfig, theme } = useContext(LayoutContext);
  const nav = useNavigate();

  const containerClassName = cn(
    'flex size-full min-h-[calc(100vh-140px)] items-center justify-center overflow-hidden bg-surface-50',
    { 'p-input-filled': layoutConfig.inputStyle === 'filled' },
  );

  const customTheme: Theme = {
    name: 'custom-theme',
    overrides: [defaultDarkModeOverride],
    tokens: {
      components: {
        authenticator: {
          router: {
            borderWidth: { value: '0px' },
            boxShadow: { value: 'none' },
          },
        },
      },
    },
  };

  return (
    <div className={containerClassName}>
      <div className="flex flex-col items-center justify-center">
        <img
          src={`/assets/images/logo/logo-${
            theme === 'light' ? 'dark' : 'light'
          }-512.png`}
          alt="Sakai logo"
          style={{ height: '200px', width: '200px' }}
          className="mb-8 shrink-0"
        />
        <div
          style={{
            borderRadius: '56px',
            padding: '0.3rem',
            background:
              'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)',
          }}
        >
          <div
            className="w-full px-8 py-8"
            style={{
              borderRadius: '53px',
              background: 'var(--surface-section)',
            }}
          >
            <div className="mb-8 text-center">
              <span className="text-lg font-bold leading-10 text-surface-600">
                Reset Password
              </span>
            </div>

            <div>
              <ThemeProvider
                colorMode={theme as 'light' | 'dark'}
                theme={customTheme}
              >
                <AccountSettings.ChangePassword
                  onSuccess={() => {
                    nav('main/dashboard', {
                      viewTransition: true,
                    });
                  }}
                ></AccountSettings.ChangePassword>
              </ThemeProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPsPage;
